import { defineStore } from 'pinia'

export const useCheckDeviceStore = defineStore('checkDevice', {
    state: () => ({checkCode: 0})
})